export const serverUrl = 'https://mock-trader-backend.onrender.com';
